module.exports = __webpack_public_path__ + "static/media/cat4.8b665bf8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cat4.jpeg
// module id = 36
// module chunks = 0